<template>
    <div class="article-project-management">
        <p>
            We handle every step of the process, from content creation to publishing, while a dedicated account manager
            liaises with the client. Our account manager’s job is to work with the client to meet all the campaign goals
            and objectives. Whether you own an online casino or sports betting business, we're here to help you climb
            the Google ladder and reach new audiences with your content.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleProjectManagement',
};
</script>
